import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import "./styles.css";

// Create root element
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

// Create React root and render app
const root = ReactDOM.createRoot(rootElement);
const router = getRouter();
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
